{
  "MeasurementsFilterField": {
    "operators": {
      "gt": "大于",
      "eq": "等于",
      "lt": "小于"
    },
    "units": {
      "cm_long": "公制 (厘米)",
      "cm": "厘米",
      "in_long": "英制 (英寸)",
      "in": "英寸",
      "m_long": "公制 (米)",
      "m": "米",
      "ft_long": "英制 (英尺)",
      "ft": "英尺"
    }
  }
}
